/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */

import React, { useEffect, useState, useRef } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import clsx from 'clsx';

import IconButton from '@material-ui/core/IconButton';

const useStyles = makeStyles((theme) => ({
  actionButtons: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 4,
    fontSize: '2rem',
    width: '20vw',

    [theme.breakpoints.down('sm')]: {
      width: '80vw',
    },
  },
  iconButton: {
    padding: theme.spacing(0.5),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    textAlign: 'center',
  },
  activeReaction: {
    backgroundColor: theme.palette.primary.main,
  },
}));

function ReactionPalette(props) {
  const theme = useTheme();
  const { reactToImage, picture, activeReaction } = props;

  const classes = useStyles();

  const emojies = [
    { name: 'thumbsup', emoji: '👍' },
    { name: 'thumbsdown', emoji: '👎' },
    { name: 'laugh', emoji: '😂' },
    { name: 'sad', emoji: '😢' },
    { name: 'angry', emoji: '😠' },
    { name: 'love', emoji: '❤️' },
    { name: 'wow', emoji: '😮' },
    { name: 'confused', emoji: '😕' },
    { name: 'poop', emoji: '💩' },
    { name: 'clap', emoji: '👏' },
    { name: 'rocket', emoji: '🚀' },
    { name: 'eyes', emoji: '👀' },
    { name: 'fire', emoji: '🔥' },
    { name: 'party', emoji: '🎉' },
    { name: '100', emoji: '💯' },
    { name: 'cool', emoji: '😎' },
    { name: 'cry', emoji: '😭' },
    { name: 'scream', emoji: '😱' },
    { name: 'sleep', emoji: '😴' },
    { name: 'sick', emoji: '🤢' },
    { name: 'thinking', emoji: '🤔' },
    { name: 'hearteyes', emoji: '😍' },
    { name: 'kiss', emoji: '😘' },
    { name: 'flying money', emoji: '💸' },
  ];

  return (
    <div className={classes.actionButtons}>
      <Grid container item xs={12}>
        {emojies.map((emoji) => (
          <Grid item xs={2} key={emoji.name}>
            <IconButton
              className={
                activeReaction === emoji.emoji
                  ? clsx(classes.iconButton, classes.activeReaction)
                  : classes.iconButton
              }
              onClick={() => reactToImage(emoji.emoji)}
              size="medium"
            >
              <span
                role="img"
                aria-label={emoji.name}
              >
                {emoji.emoji}
              </span>
            </IconButton>
          </Grid>
        ))}
      </Grid>
    </div>
  );
}

export default ReactionPalette;
